import React, {Component} from 'react'
import {observer} from 'mobx-react'
import Tabs from "../../../lib/struct/Tabs"
import SaveButton from "../../../lib/struct/page/SaveButton"
// import TokenTab from "./Tabs/TokenTab"
import TopBar from "./TopBar/TopBar"
import Status from 'lib/control/Status'

import styles from "./SettingsPageComponent.less"
import CampaignTab from "./Tabs/CampaignTab";
import TokenTab from "./Tabs/TokenTab";
import CampaignSettings from "../../model/CampaignSettings"
import Field from '../struct/Field'
import Checkbox from "lib/control/Checkbox"

const {
    'pokupki-settings': WrapperClass,
} = styles

const labels = {
    'DBS': 'DBS',
    'FBS': 'FBS',
    'FBSX': 'FBS Express',
}

let RegionDeliveryOptions = [
    {
        label: '',
        value: 0,
    },
]

let RegionPaymentOptions = [
    {
        label: '',
        value: 0,
    },
]

let max_id = 0
let max_tab_id = 0

@observer export default class SettingsPageComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected_tab_idx: 0,
            status: Status.NONE,
            error: false,
            campaigns_to_delete: [],
            // debug: props.context.settings.debug === "true"
        }
        this.success_timeout_id = 0

        this.changeSelectedTab = this.changeSelectedTab.bind(this)
        this.changeState = this.changeState.bind(this)
        this.saveSettings = this.saveSettings.bind(this)
        props.context.delivery_methods.map((method) => {
            RegionDeliveryOptions.push({
                label: method.name,
                value: method.id,
            })
        })
        props.context.delivery_methods = RegionDeliveryOptions
        props.context.shop_payment_methods.map((method) => {
            RegionPaymentOptions.push({
                label: method.name,
                value: method.id,
            })
        })
        props.context.shop_payment_methods = RegionPaymentOptions
        this.addTab = this.addTab.bind(this)
        this.deleteCampaign = this.deleteCampaign.bind(this)
    }

    changeSelectedTab(new_idx) {
        this.setState({
            selected_tab_idx: new_idx
        })
    }

    changeState(prop, val) {
        this.setState({
            [prop]: val
        })
    }

    addTab() {
        max_id += 1
        let comp = new CampaignSettings({id:max_id})
        if(comp) {
            this.props.context.campaigns[max_id] = comp
            max_tab_id += 1
            this.changeSelectedTab(max_tab_id)
        } else {
            max_id -= 1
        }
    }

    deleteCampaign(id){
        delete (this.props.context.campaigns[id])
        let ids = this.state.campaigns_to_delete
        ids.push(id)
        this.setState({campaigns_to_delete: ids})
    }

    handleChangeDebug = (checked) => {
        this.setState({
            debug: checked
        })

        this.props.context.settings.debug = checked
    }

    render() {
        /** @type {SettingsContext} */
        const context = this.props.context
        context.saveSettings = this.saveSettings
        /** @type {ApiSettings} */
        const settings = context.settings
        const api_url = context.api_url
        let tabs = []
        tabs.push({
            label: 'Общие',
            content: <TokenTab settings={settings} context={context}/>,
        })
        max_tab_id = 0
        for (const [id, campaign] of Object.entries(this.props.context.campaigns)) {
            max_id = Math.max(max_id, id)
            max_tab_id++
            let type = campaign.type
            tabs.push({
                label: campaign.custom ? campaign.name : labels[type],
                content: <CampaignTab settings={settings} statuses={this.getActionsOptions(context.actions)}
                                 context={context} campaign={campaign} selected_id={id} api_url={api_url}
                                 changeSelectedTab={this.changeSelectedTab}
                                 onCampaignDelete={this.deleteCampaign}/>,
            })
        }

        return (
            <React.Fragment>
                <TopBar/>
                <Tabs tabs={tabs}
                      selected_tab_idx={this.state.selected_tab_idx}
                      changeParentState={this.changeState}
                      className={WrapperClass}
                      onTabAdd={this.addTab}
                />
                <SaveButton onSaveClick={() => this.saveSettings()} status={this.state.status} error={this.state.error}/>
            </React.Fragment>
        )
    }

    async saveSettings() {
        if(this.props.context.is_create_region) {
            this.props.context.saveRegion()
        }

        let tokens = []
        for (const [id, campaign] of Object.entries(this.props.context.campaigns)) {
            if(tokens.indexOf(campaign.auth_token) >= 0 && campaign.auth_token !== '' && campaign.auth_token !== undefined) {
                this.setState({
                    status: Status.ERROR,
                    error: 'Авторизационные токены в разных профилях не могут совпадать'
                })
                return false
            }
            if(campaign.auth_token !== ''  && campaign.auth_token !== undefined) {
                tokens.push(campaign.auth_token)
            }
        }

        const conditions = {}
        for (const campaignName in this.props.context.campaigns) {
            if (this.props.context.campaigns[campaignName].condition) {
                conditions[this.props.context.campaigns[campaignName].id] = this.props.context.campaigns[campaignName].condition.conditionsArray
                this.props.context.campaigns[campaignName].condition = undefined
            }
        }
        const save_data = {
            'settings': this.props.context.settings,
            'campaigns': this.props.context.campaigns,
            'conditions': conditions,
            'campaigns_to_delete': this.state.campaigns_to_delete,
            'regions_to_delete': this.props.context.regions_to_delete,
            'pvz_to_delete': this.props.context.pvz_to_delete,
            'conditions_to_delete': this.props.context.conditions_to_delete
        };

        clearTimeout(this.success_timeout_id)
        this.setState({
            status: Status.LOADING
        })

        try {
            $.ajax({
                url: '?plugin=pokupki&module=settings&action=saveSettings',
                method: 'POST',
                dataType: 'json',
                data: {data: JSON.stringify(save_data)}
            }).then(
                response => {

                    if (response.status == 'ok') {

                        let campaigns = {}
                        for (const [id, campaign] of Object.entries(response.data.params.campaigns)) {
                            campaigns[id] = new CampaignSettings(campaign)
                        }
                        this.setState({
                            campaigns: campaigns,
                            campaigns_to_delete: []
                        })
                        this.props.context.campaigns = campaigns
                        this.props.context.settings = response.data.params.settings ? response.data.params.settings : this.props.context.settings


                        this.setState({
                            status: Status.SUCCESS,
                            error: false
                        })

                        this.success_timeout_id = setTimeout(() => {
                            this.setState({
                                status: Status.NONE,
                                error: false
                            })
                        }, 1000)
                    } else {
                        this.setState({
                            status: Status.ERROR,
                            error: response.errors ? response.errors[0][0] : ''
                        })
                    }
                },
                () => {
                    this.setState({
                        status: Status.ERROR,
                        error: ''
                    })
                }
            )

        } catch (e) {
            console.warn(e)
            this.setState({
                status: Status.ERROR
            })
            return false
        }
    }


    getActionsOptions(actions) {
        let result = []
        Object.keys(actions).map((key, i) => {
            result.push({
                label: actions[key],
                value: key,
            })
        })

        return result
    }
}